// App Window types declare a full Betslip on ocBetslip; this package needs a minimal local shape.
// Omit host keys before intersecting so we do not require the full CDN Betslip surface.
export type OcWindow = Omit<Window, 'oc' | 'ocBetslip' | 'ocRenderers' | 'xtremepush'> & {
  oc: { betslipAdvertActive: boolean; redirectUrl?: string };
  ocBetslip: {
    [key: string]: unknown;
    getBetCount: () => number;
    setCallbacks: (callbacks: { setBetCount?: () => void }) => void;
    toggle: () => void;
  };
  ocRenderers: Record<string, (props: unknown) => void>;
  xtremepush?: (action: 'get' | 'set', key: string, value?: string | number) => unknown;
};

export const getOcWindow = (): OcWindow => window as unknown as OcWindow;
